<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Products') }}</Tab>
                <Tab value="2">{{ __('Attachments') }}</Tab>
                <Tab value="3">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="order_name"
                                       label="Order name"
                                       validation="required"
                                       size="4"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.order_name" />
                        <FormInputText fieldName="order_number"
                                       label="Number"
                                       size="2"
                                       :isFormDisabled="true"
                                       v-model:field="crud.order_number" />
                        <FormSelect fieldName="contractor_id"
                                    label="Contractor"
                                    size="3"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.contractors"
                                    v-model:field="crud.contractor_id" />

                        <FormSelect fieldName="status_id"
                                    label="Status"
                                    size="3"
                                    :isFormDisabled="true"
                                    :options="select?.statuses"
                                    v-model:field="crud.status_id" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="creator_id"
                                    label="Creator"
                                    size="2"
                                    :isFormDisabled="true"
                                    :options="select?.users"
                                    v-model:field="crud.creator_id" />

                        <FormCalendar fieldName="creation_date"
                                      label="Creation date"
                                      size="2"
                                      validation="required"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.creation_date" />
                    </div>
                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.description" />
                    </div>
                </TabPanel>

                <TabPanel value="1">
                    <div :name="'order_products'"></div>
                    <FormRepeaterTable v-model:record="crud.order_products"
                                       :keys="{ 'product_id': null, 'offer_id': null, 'section': null, 'quantity': null, 'description': null, 'picture': null }"
                                       :isFirstRowEmpty="false"
                                       :isCopyButton="false"
                                       :addButtonName="__('Add product')"
                                       repeaterStyle="margin-top:13px;width:99%"
                                       name="order_products"
                                       :title="[__('Product'), __('Offer'), __('Section name'), __('Quantity'), __('Description'), __('Picture')]">

                        <template #repeat="slotProps">
                            <td style="width:25%;"
                                :style="slotProps.cellStyle">
                                <FormSelect fieldName="product_id"
                                            inputClass="required-field"
                                            :inRepeater="true"
                                            :options="select?.products"
                                            :change="(e) => insertProductDataIntoRow(e, slotProps.record)"
                                            v-model:field="slotProps.record.product_id" />
                            </td>
                            <td style="width:20%"
                                :style="slotProps.cellStyle">
                                <FormSelect fieldName="offer_id"
                                            :inRepeater="true"
                                            :isFormDisabled="true"
                                            :options="select?.offers"
                                            v-model:field="slotProps.record.offer_id" />
                            </td>
                            <td style="width:20%"
                                :style="slotProps.cellStyle">
                                <FormTextarea fieldName="section"
                                              :inRepeater="true"
                                              :isFormDisabled="true"
                                              :rows="2"
                                              v-model:field="slotProps.record.section" />
                            </td>
                            <td style="width:5%"
                                :style="slotProps.cellStyle">
                                <FormInputNumber fieldName="quantity"
                                                 class="required-field"
                                                 :inRepeater="true"
                                                 :minFractionDigits="2"
                                                 :maxFractionDigits="2"
                                                 v-model:field="slotProps.record.quantity" />
                            </td>
                            <td style="width:25%"
                                :style="slotProps.cellStyle">
                                <FormTextarea fieldName="description"
                                              :inRepeater="true"
                                              :rows="3"
                                              v-model:field="slotProps.record.description" />
                            </td>
                            <td style="width:5%"
                                :style="slotProps.cellStyle">
                                <span>
                                    <img v-if="slotProps.record.picture"
                                         style="width:100px;height:100px;object-fit:cover;"
                                         :src="slotProps.record.picture" />
                                </span>
                            </td>

                            <!-- <td style="width:10%;border-width:1px;">
                                <FormFileUploader fieldName="files"
                                                  category="documents"
                                                  imgPosition="left"
                                                  :inRepeater="true"
                                                  :isShortNames="true"
                                                  :showSizeInfo="false"
                                                  :allowedExtensions="['pdf', 'docx', 'xlsx', 'txt', 'jpg', 'jpeg', 'png', 'gif']"
                                                  :style="{ minWidth: '100px', display: 'flex', flexDirection: 'column-reverse' }"
                                                  v-model:field="slotProps.record.files" />
                            </td> -->
                        </template>
                    </FormRepeaterTable>
                </TabPanel>

                <TabPanel value="2">
                    <div class="grid">
                        <FormFileUploader fieldName="files"
                                          label="Documents"
                                          category="documents"
                                          :allowedExtensions="['pdf', 'docx', 'xlsx', 'txt']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />
                        <FormFileUploader fieldName="files"
                                          label="Pictures"
                                          category="pictures"
                                          imgPosition="right"
                                          :allowedExtensions="['jpg', 'jpeg', 'png', 'gif']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="3"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :beforeSave="beforeSave"
                         :buttonsVisibility="formProps.buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">

                <template #after-in-edit>
                    <AlertAddButton :addAlert="addAlert" />
                </template>
            </FormButtons>
        </div>

        <AlertAdd :formProps="{ source_table: 'quotations', source_id: crud.id, width: '50%' }"
                  v-model:isAddAlertDialogOpen="isAddAlertDialogOpen" />
    </v-form>

</template>

<script setup>
import { ref, onMounted, toRaw } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import FormRepeaterTable from '@crud/FormRepeaterTable.vue'
import FormTextarea from '@crud/FormTextarea.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormFileUploader from '@crud/FormFileUploader.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import AlertAdd from '@app/Data/Alert/AlertAdd.vue'
import AlertAddButton from '@alert/AlertAddButton.vue'
import { __, getStoreValue, getStatusId, currentDate, getFromRoute, buttonClass, screenMessage, printReport } from '@helper/utils.js'
import { validation, initFormObj } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
    opportunityData: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})
const buttonsVisibility = ref({})

const options = ["statuses", "contractors", "users", "products", "offers"];
const select = ref(null);
const isAddAlertDialogOpen = ref(false);

// -----------------------------------------------------

onMounted(async () => {
    await initFormObj({ props, crud, isLoading, options, select, paramsToSelect: { 'statuses': { 'status_category': 'STA_ORDER' }, 'contractors': { 'custom_type': 'SUPPLIERS' }, 'products': { 'custom_type': 'READY_TO_ORDER' } } })
    await changeProductsAndOffersList(); // Inicjalne ustawienie listy produktów (wszystkie produkty, ponieważ nie ma jeszcze wybranego asortymentu)

    crud.value?.order_products?.forEach(product => {
        if (product.id) {
            insertProductDataIntoRow({ value: product.id }, product);
        }
    });

    if (props.formProps.addMode == true) {
        crud.value.creator_id = getStoreValue('myId');
        crud.value.status_id = await getStatusId('STA_ORDER', 'SYM_REGISTERED');
        crud.value.creation_date = currentDate();
    }
})

// -----------------------------------------------------

const changeProductsAndOffersList = async () => {
    const response = await getFromRoute('product-pictures', {
        products: select.value.products.reduce((acc, product) => {
            const key = `${product.value}_${product.offer_id ?? 0}_${product.section ?? ''}`;
            acc[key] = {
                label: product.label, part_number: product.part_number, features: product.features,
                offer: { offer_name: product.offer_name, offer_number: product.offer_number, assortment_id: product.assortment_id, section: product.section }
            }; return acc;
        }, {})
    }, 'post');

    select.value.products = select.value.products.map(product => {
        const key = `${product.value}_${product.offer_id ?? 0}_${product.section ?? ''}`;
        const pictureWithLabel = response.labels[key];
        return { ...product, label: pictureWithLabel ? pictureWithLabel : product.label, picture: response.pictures[key] || null, value: product.value + '_' + (product.offer_id ?? 0) + '_' + (product.section ?? '') };
    });
}

// -----------------------------------------------------

const insertProductDataIntoRow = (e, rowData) => {
    const selectedProduct = select.value.products.find(product => (product.value == rowData.product_id + '_' + (rowData.offer_id ?? 0) + '_' + (rowData.section ?? '')) || product.value === e.value);
    if (selectedProduct) {
        rowData.product_id = selectedProduct.value
        rowData.quantity = !rowData.quantity ? selectedProduct.quantity : rowData.quantity;
        rowData.offer_id = selectedProduct.offer_id;
        rowData.section = selectedProduct.section;
        rowData.picture = selectedProduct.picture;
    }
}

// -----------------------------------------------------

const beforeSave = () => {
    const copyOrderProducts = crud.value.order_products?.map(product => {
        const rawProduct = toRaw(product);
        if (rawProduct.product_id) {
            const productId = String(rawProduct.product_id).split('_')[0];
            return { ...rawProduct, product_id: productId };
        }
        return { ...rawProduct };
    });

    return { ...crud.value, order_products: copyOrderProducts };
}

// -----------------------------------------------------

const addAlert = async () => {
    isAddAlertDialogOpen.value = true;
}

// -----------------------------------------------------


</script>

<style lang="scss" scoped></style>
